<template>
  <div class="d-flex">
    <div
      v-for="(data, key) in stepsMeasure"
      :key="key"
      class="col timeline d-flex flex-column justify-content-between"
      :class="data.class"
    >
      <h5 v-html="data.title" class="mb-1" />
      <p>{{ data.description ? data.description : '-' }}</p>
    </div>
  </div>
</template>

<script>
import MeasureStatusEnum from '@/enum/measureStatusEnum'
import { dateTimeSqlToDateTimeBR } from '@/utils/date'

export default {
  name: 'StepsMeasure',

  props: {
    status: {
      type: String,
      required: true,
    },
    logs: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      stepsMeasure: [],
      structure: [
        {
          title: 'Medição Realizada',
          useOriginalTitle: true,
          logDescription: ['Cadastrou uma medição'],
        },
        {
          title: 'Aprovado pelo Gerente',
          useOriginalTitle: false,
          logDescription: [
            'Aprovado pelo Gerente',
            'Aprovado pelo Gerente (Consulta Seven)',
          ],
        },
        {
          title: 'Aprovado pela Ger. Financeira',
          useOriginalTitle: false,
          logDescription: [
            'Aprovado pela Contabilidade',
            'Aprovado pela Ger. Financeira',
          ],
        },
        {
          title: 'Nota Fiscal / XML',
          useOriginalTitle: true,
          logDescription: ['Medição de IDMOV'],
        },
      ],
      completeClass: 'bg-success',
      pendingClass: 'bg-success bg-opacity-25 text-dark',
      reprovedClass: 'bg-danger bg-opacity-25 text-dark',
    }
  },

  methods: {
    generateArray() {
      let isReproved = false

      this.structure.forEach((item) => {
        const step = this.getStepTitle(
          item.title,
          item.useOriginalTitle,
          item.logDescription,
        )

        let classColor = this.completeClass

        if (step.title === null) {
          if (!isReproved) {
            if (this.status === MeasureStatusEnum.REPROVADO) {
              step.title = 'Reprovado'
              classColor = this.reprovedClass
              isReproved = true
            } else if (this.status === MeasureStatusEnum.CANCELADO) {
              step.title = 'Cancelado'
              classColor = this.reprovedClass
              isReproved = true
            } else {
              step.title = 'Pendente'
              classColor = this.pendingClass
            }
          } else {
            step.title = 'Reprovado/cancelado na etapa anterior'
            classColor = this.pendingClass
          }
        }

        this.stepsMeasure.push({
          title: step.title ?? item.title,
          description: step.description,
          class: classColor,
        })
      })

      this.stepsMeasure = this.stepsMeasure.map((step) => {
        if (step.title === 'Cancelado' || step.title === 'Reprovado') {
          const logFinded = this.logs.find(
            (log) =>
              log.description.includes('Cancelado') ||
              log.description.includes('Reprovado'),
          )
          return {
            ...step,
            description: `${dateTimeSqlToDateTimeBR(logFinded.createdAt)} por ${
              logFinded.createdBy
            }`,
          }
        }
        return step
      })
    },

    getStepTitle(itemTitle, useOriginalTitle, logDescriptions) {
      let title = null
      let description = null

      logDescriptions.forEach((logDescription) => {
        const logFinded = this.logs.find((log) =>
          log.description.includes(logDescription),
        )

        if (logFinded) {
          title = useOriginalTitle ? itemTitle : logFinded.description
          description = `${dateTimeSqlToDateTimeBR(logFinded.createdAt)} por ${
            logFinded.createdBy
          }`
        }
      })

      if (title !== null) {
        title = title.replace(/\(/g, '<br>(')
      }

      return { title, description }
    },
  },

  mounted() {
    this.generateArray()
  },
}
</script>

<style scoped>
.timeline {
  text-align: -webkit-center;
  padding: 0.3rem;
  color: white;
  border: 0.1rem solid white;
  border-radius: 0.3rem;
  clip-path: polygon(0% 0%, 90% 0%, 100% 50%, 90% 100%, 0% 100%, 10% 50%);
}

.timeline > h5 {
  font-size: 1rem;
}

.timeline > p {
  margin-bottom: 0px;
  font-size: 0.7rem;
}

.bg-item {
  background-color: var(--color-primary-dark) !important;
  color: var(--color-primary-lighter);
}
</style>
